import $ from "cash-dom";
function addPaginationArrows($pagination) {
    const isFirstItemActive = $pagination.find('.Pagination-item:first-child').hasClass('isCurrent');
    const isLastItemActive = $pagination.find('.Pagination-item:last-child').hasClass('isCurrent');

    $pagination.wrap('<div class="Pagination-toolbar"></div>');
    if(isFirstItemActive) {
        $pagination.prepend(`<li class="previous"><div class="icon icon-arrow-left pagination-nav inactive"></div></li>`);
    } else {
        $pagination.find('.previous a').html('<div class="icon icon-arrow-left pagination-nav"></div>');
        $('.search-results--collapsed').removeClass('search-results--collapsed');
    }

    if(isLastItemActive) {
        $pagination.append(`<li class="next"><div class="icon icon-arrow-right pagination-nav inactive"></div></li>`);
    } else {
        $pagination.find('.next a').html('<div class="icon icon-arrow-right pagination-nav"></div>');
    }
}

function hideIrrelevantPages($pagination) {
    const $paginationItems = $pagination.find('.Pagination-item');
    const $firstItem = $paginationItems.first();
    const $lastItem = $paginationItems.last();
    const $currentItem = $pagination.find('.Pagination-item.isCurrent');
    const $prevPageItem = $currentItem.prev();
    const $nextPageItem = $currentItem.next();
    const $nextButOnePageItem = $nextPageItem.next();

    const visibleItems = [$firstItem.html(), $lastItem.html(), $currentItem.html(), $prevPageItem.html(), $nextPageItem.html(), $nextButOnePageItem.html()];


    $paginationItems.each(function() {
        const $paginationItem = $(this);
        if(!visibleItems.includes($paginationItem.html())) {
            $(this).addClass('hidden');

            if(!$(this).prev().hasClass('hidden')) {
                $(this).before('<span class="Pagination-spacer">...</span>');
            }
        }
    });
}

function InitHeaderSearchField() {
    const searchParams = new URLSearchParams(window.location.search);
    const headerSearchField = document.getElementById('product-search--header');

    if (!!headerSearchField && !!searchParams && !!searchParams.get('search')) {
        headerSearchField.value = searchParams.get('search');
    }

}

export default function InitSearch() {
    $('.Pagination').each(function() {
        addPaginationArrows($(this));
        hideIrrelevantPages($(this));
    });

    if(!!$(['data-action-onload="fill-header-search"'])) {
        InitHeaderSearchField();
    }
}
